import React, { Component } from 'react';

import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';

import { inject, observer } from 'mobx-react';
import VideoStore from '../stores/videoStore';

// import YouTube from 'react-youtube';
import ReactPlayer from 'react-player';


/*
        'https://www.youtube.com/watch?v=7ASThWpIGww',
        'https://vimeo.com/17152530',
        'https://www.dailymotion.com/video/x6q5ues',
        */

  
@inject('videoStore')
@observer
class ViewVideos extends Component {

  render() {
    const store = this.props.videoStore;
  
    const opts = {
      height: height,
      width: width,
      playerVars: { // https://developers.google.com/youtube/player_parameters
        autoplay: 1
      }
    };

    let height = Math.floor(((store.height - 40) / 2) - 12);  // Handle header and extra padding...
    let width = Math.floor((store.width / 2));

    return (
      <div className="videoContainer">
        { store.videos.map(v => {
            return (
              <ReactPlayer key={v} url={v}
                height={height}
                width={width}
                config={{
                  youtube: {playerVars: {showinfo: 1}}
                }}
                playing
                controls
                muted /> 
            ); }
          )
        }
        { /* (store.videos.length < 4) ?
          <Button className="App-button" aria-label="Add" variant="fab" color="secondary" onClick={store.handleAddOpen}>
            <AddIcon />
          </Button> :
          null
        */ }
      </div>
    );
  }
}

export default ViewVideos;


// WEBPACK FOOTER //
// ./src/components/ViewVideos.js